import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../../assets/css/admin/dashboard/Bookingmanagement.css';
import AdminLayout from '../../../../layouts/admin/AdminLayout';
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const avatarColors = {
  A: "#7c3aed", S: "#10b981", H: "#f59e0b",
  F: "#ef4444", Z: "#3b82f6", U: "#ec4899",
  M: "#7c3aed", B: "#10b981", R: "#f59e0b",
};

const getPaymentInfo = (booking) => {
  const isPaid = booking.paymentStatus === 'paid';
  const remaining = Number(booking.remainingAmount) || 0;

  if (!isPaid) {
    return { isPaid: false, label: 'Unpaid', color: '#f59e0b', icon: '⏳' };
  }
  if (remaining > 0) {
    return { isPaid: true, label: 'Advance Paid', color: '#3b82f6', icon: '💵' };
  }
  return { isPaid: true, label: 'Full Paid', color: '#10b981', icon: '✅' };
};

// ✅ FIX: eventType ab seedha Webooking row ka column hai (My Event screen
// hatane ke baad). Purani bookings (jo us se pehle bani thi) ke liye
// weevent?.eventName fallback rakha hai taake wo khaali na dikhein.
const getEventName = (booking) => booking.eventType || booking.weevent?.eventName || 'N/A';

const BookingManagement = () => {
  const [bookings,    setBookings]   = useState([]);
  const [activeTab,   setActiveTab]  = useState("all");
  const [search,      setSearch]     = useState("");
  const [dateFilter,  setDateFilter] = useState("");
  const [viewModal,   setViewModal]  = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [tabLoading, setTabLoading] = useState(null);

  const { baseUrl } = useContext(AppContext);

  const viewAllBookings = () => {
    axios.post(`${baseUrl}/admin/bookings/viewAllBookings`, {}, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      if (res.data.success === true) {
        setBookings(res.data.bookings);
      }
      setPageLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setPageLoading(false);
    });
  };

  const updateStatus = (id, status) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("actions", status);

    axios.post(`${baseUrl}/admin/bookings/updateBooking`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      if (res.data.success === true) {
        setBookings(prev => prev.map(b => b.id === id ? { ...b, status: status } : b));
      }
    })
    .catch((err) => console.log(err));
  };

  const deleteBooking = (id) => {
    axios.delete(`${baseUrl}/admin/bookings/deleteBooking/${id}`)
    .then((res) => {
      if (res.data.success === true) {
        setBookings(prev => prev.filter(b => b.id !== id));
      }
    })
    .catch((err) => console.log(err));
  };

  useEffect(() => {
    viewAllBookings();
  }, []);

  const handleTabClick = (key) => {
    setTabLoading(key);
    setTimeout(() => {
      setActiveTab(key);
      setTabLoading(null);
    }, 600);
  };

  const counts = {
    all:       bookings.length,
    pending:   bookings.filter(b => b.status === "pending").length,
    approved:  bookings.filter(b => b.status === "approved").length,
    cancelled: bookings.filter(b => b.status === "cancelled").length,
  };

  const filtered = bookings.filter(b => {
    const tabMatch = activeTab === "all" ? true : b.status === activeTab;
    const q = search.toLowerCase();
    const userName  = `${b.wecustomer?.firstName || ''} ${b.wecustomer?.lastName || ''}`.toLowerCase();
    const eventName = getEventName(b).toLowerCase();
    const venueName = (b.wevenue?.venueName || '').toLowerCase();
    const searchMatch = !q ||
      String(b.id).toLowerCase().includes(q) ||
      userName.includes(q) ||
      eventName.includes(q) ||
      venueName.includes(q);
    const dateMatch = !dateFilter || b.date.includes(dateFilter);
    return tabMatch && searchMatch && dateMatch;
  });

  const exportCSV = () => {
    const rows = ["ID,User,Event,Venue,Date,Amount,PaymentStatus,Status",
      ...bookings.map(b =>
        `${b.id},${b.wecustomer?.firstName || ''} ${b.wecustomer?.lastName || ''},${getEventName(b)},${b.wevenue?.venueName || 'N/A'},${b.date},${b.totalAmount || 'N/A'},${getPaymentInfo(b).label},${b.status}`
      )
    ];
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "text/csv" }));
    a.download = "bookings.csv";
    a.click();
  };

  const tabs = [
    { key: "all",       label: "All Bookings", icon: "📋" },
    { key: "pending",   label: "Pending",      icon: "⏳" },
    { key: "approved",  label: "Approved",     icon: "✅" },
    { key: "cancelled", label: "Cancelled",    icon: "❌" },
  ];

  return (
    <AdminLayout>
      <div className="bm-wrapper">

        {/* Header */}
        <div className="bm-header d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4">
          <div>
            <h1 className="bm-title">Booking Management</h1>
            <p className="bm-subtitle">All venue booking requests — pending, approved &amp; cancelled</p>
          </div>
          <button className="bm-export-btn" onClick={exportCSV}>⬇ Export CSV</button>
        </div>

        {/* Stat Cards */}
        <div className="row g-3 mb-4">
          {[
            { label: "Total Bookings", value: counts.all,       icon: "📦", cls: "bm-stat--purple" },
            { label: "Pending",        value: counts.pending,   icon: "⏳", cls: "bm-stat--yellow" },
            { label: "Approved",       value: counts.approved,  icon: "✅", cls: "bm-stat--green"  },
            { label: "Cancelled",      value: counts.cancelled, icon: "❌", cls: "bm-stat--red"    },
          ].map(c => (
            <div className="col-6 col-md-3" key={c.label}>
              <div className={`bm-stat-card ${c.cls}`}>
                <div className="bm-stat-icon">{c.icon}</div>
                <div>
                  <div className="bm-stat-value">{c.value}</div>
                  <div className="bm-stat-label">{c.label}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div className="bm-tabs mb-3">
          {tabs.map(t => (
            <button
              key={t.key}
              className={`bm-tab ${activeTab === t.key ? "bm-tab--active" : ""}`}
              onClick={() => handleTabClick(t.key)}
              disabled={tabLoading === t.key}
            >
              {tabLoading === t.key ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              ) : (
                <>{t.icon} </>
              )}
              {t.label}
              <span className="bm-tab-badge">{counts[t.key]}</span>
            </button>
          ))}
        </div>

        {/* Filters */}
        <div className="row g-2 mb-3">
          <div className="col-12 col-md-6">
            <div className="bm-search-wrap">
              <span className="bm-search-icon">🔍</span>
              <input
                className="bm-search"
                placeholder="Search by booking ID, user, event, venue..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="bm-date-wrap">
              <span className="bm-date-icon">📅</span>
              <input
                type="date"
                className="bm-date"
                value={dateFilter}
                onChange={e => setDateFilter(e.target.value)}
              />
            </div>
          </div>
          <div className="col-12 col-md-2">
            <button
              className="bm-reset-btn w-100"
              onClick={() => { setSearch(""); setDateFilter(""); }}
            >
              🔄 Reset
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="bm-table-card">
          <div className="table-responsive">
            {pageLoading ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Loading...
              </div>
            ) : (
              <table className="bm-table w-100">
                <thead>
                  <tr>
                    {["BOOKING ID","USER","EVENT","VENUE","DATE","AMOUNT","PAYMENT","STATUS","ACTIONS"].map(h => (
                      <th key={h}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 && (
                    <tr>
                      <td colSpan={9} style={{ textAlign: "center", padding: "40px 0", color: "#9ca3af" }}>
                        No bookings found 😕
                      </td>
                    </tr>
                  )}
                  {filtered.map((b, i) => {
                    const firstName   = b.wecustomer?.firstName || '';
                    const lastName    = b.wecustomer?.lastName  || '';
                    const fullName    = `${firstName} ${lastName}`.trim() || 'Unknown';
                    const firstLetter = firstName.charAt(0).toUpperCase() || 'U';
                    const eventName   = getEventName(b);
                    const venueName   = b.wevenue?.venueName   || 'N/A';
                    const amount      = b.totalAmount ? `Rs. ${b.totalAmount}` : 'N/A';
                    const status      = b.status || '';
                    const paymentInfo = getPaymentInfo(b);

                    return (
                      <tr key={b.id} className={i % 2 === 0 ? "bm-row-even" : "bm-row-odd"}>

                        <td>
                          <span className={`bm-id-badge bm-id--${status}`}>#{b.id}</span>
                        </td>

                        <td>
                          <div className="bm-user">
                            <div className="bm-avatar" style={{ background: avatarColors[firstLetter] || "#7c3aed" }}>
                              {firstLetter}
                            </div>
                            <div>
                              <div className="bm-user-name">{fullName}</div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <div className="bm-event-name">{eventName}</div>
                        </td>

                        <td>
                          <div className="bm-event-name">{venueName}</div>
                        </td>

                        <td>
                          <span className="bm-date-badge">📅 {b.date}</span>
                        </td>

                        <td>
                          <span className="bm-amount-badge">{amount}</span>
                        </td>

                        <td>
                          <span style={{ color: paymentInfo.color, fontWeight: 600, fontSize: '13px' }}>
                            {paymentInfo.icon} {paymentInfo.label}
                          </span>
                        </td>

                        <td>
                          <span className={`bm-status bm-status--${status}`}>
                            {status === "pending"   && "⏳ Pending"}
                            {status === "approved"  && "✅ Approved"}
                            {status === "cancelled" && "❌ Cancelled"}
                            {!status               && "❓ N/A"}
                          </span>
                        </td>

                        <td>
                          <div className="bm-actions">
                            <button className="bm-btn bm-btn--view" onClick={() => setViewModal(b)}>👁 View</button>

                            {status !== "approved" && (
                              paymentInfo.isPaid ? (
                                <button className="bm-btn bm-btn--approve" onClick={() => updateStatus(b.id, "approved")}>✓ Approve</button>
                              ) : (
                                <button className="bm-btn bm-btn--approve" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }} title="Advance payment abhi tak nahi hui">
                                  ✓ Approve
                                </button>
                              )
                            )}

                            {status !== "cancelled" && <button className="bm-btn bm-btn--reject" onClick={() => updateStatus(b.id, "cancelled")}>✕ Reject</button>}
                            <button className="bm-btn bm-btn--reject" onClick={() => deleteBooking(b.id)}>🗑 Delete</button>
                          </div>
                        </td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* View Modal */}
        {viewModal && (() => {
          const mFirstName = viewModal.wecustomer?.firstName || '';
          const mLastName  = viewModal.wecustomer?.lastName  || '';
          const mFullName  = `${mFirstName} ${mLastName}`.trim() || 'Unknown';
          const mEvent     = getEventName(viewModal);
          const mVenue     = viewModal.wevenue?.venueName    || 'N/A';
          const mPackage   = viewModal.wepackage?.packageName || 'N/A';
          const mTotal     = viewModal.totalAmount ? `Rs. ${viewModal.totalAmount}` : 'N/A';
          const mAdvance   = viewModal.advanceAmount ? `Rs. ${viewModal.advanceAmount}` : 'N/A';
          const mRemaining = viewModal.remainingAmount ? `Rs. ${viewModal.remainingAmount}` : 'N/A';
          const mPaymentInfo = getPaymentInfo(viewModal);
          const mStatus    = viewModal.status || '';
          const mStatusLabel = mStatus.charAt(0).toUpperCase() + mStatus.slice(1) || 'N/A';

          return (
            <div className="bm-modal-overlay" onClick={() => setViewModal(null)}>
              <div className="bm-modal" onClick={e => e.stopPropagation()}>
                <button className="bm-modal-close" onClick={() => setViewModal(null)}>✕</button>

                <div className="bm-modal-header">
                  <span className="bm-modal-icon">📋</span>
                  <h2>Booking Details</h2>
                  <p>#{viewModal.id}</p>
                </div>

                <div className="bm-modal-body">
                  {[
                    ["👤 User",      mFullName],
                    ["🎉 Event",     mEvent],
                    ["🏛 Venue",     mVenue],
                    ["📦 Package",   mPackage],
                    ["📅 Date",      viewModal.date],
                    ["💰 Total Amount", mTotal],
                    ["💵 Advance Paid", mAdvance],
                    ["💳 Remaining",    mRemaining],
                    ["🧾 Payment Status", `${mPaymentInfo.icon} ${mPaymentInfo.label}`],
                    ["📊 Status",    mStatusLabel],
                  ].map(([label, value]) => (
                    <div key={label} className="bm-modal-row">
                      <span>{label}</span>
                      <strong>{value}</strong>
                    </div>
                  ))}
                </div>

                <div className="bm-modal-footer">
                  {mStatus !== "approved" && (
                    mPaymentInfo.isPaid ? (
                      <button className="bm-btn bm-btn--approve" style={{ flex: 1, justifyContent: "center" }}
                        onClick={() => { updateStatus(viewModal.id, "approved"); setViewModal(null); }}>
                        ✓ Approve
                      </button>
                    ) : (
                      <button className="bm-btn bm-btn--approve" disabled style={{ flex: 1, justifyContent: "center", opacity: 0.5, cursor: 'not-allowed' }}>
                        ✓ Approve (Payment Pending)
                      </button>
                    )
                  )}
                  {mStatus !== "cancelled" && (
                    <button className="bm-btn bm-btn--reject" style={{ flex: 1, justifyContent: "center" }}
                      onClick={() => { updateStatus(viewModal.id, "cancelled"); setViewModal(null); }}>
                      ✕ Reject
                    </button>
                  )}
                  <button className="bm-btn bm-btn--close" style={{ flex: 1, justifyContent: "center" }}
                    onClick={() => setViewModal(null)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      </div>
    </AdminLayout>
  );
};

export default BookingManagement;